import { useMutation } from '@tanstack/react-query';

import { updateInteractionOwner } from '../api/magellan/tender';

export function useUpdateOwnerMutation() {
  return useMutation({
    mutationFn: ({
      ownerId,
      tenderId,
    }: {
      ownerId: string;
      tenderId: number;
    }) => updateInteractionOwner(ownerId, tenderId),
  });
}
